<div class="casino-provider">

    <div class="provider-card" *ngFor="let provider of providers" (click)="openProvider(provider)">
        <div class="provider-image">
            <img [src]="provider.image" alt="" />
        </div>
    </div>

</div>